const initState = {
    allSessions: [],
    sessionsForToday: [],
    currentStaffSessionsForToday: [],
    currentStaffActiveSession: null,
    currentStaffSessionsToVerify: [],

    //Modals:
    startSessionModalOpen: false,
    endSessionModalOpen: false,
    sessionIdToBeClosed: null,
    verifyAndInfoSessionsModalOpen: false,
    confirmCloseStaffSessionModalOpen: false,
    confirmCloseStaffSessionOpenedID: null,
};

const StaffSessionReducer = (state = initState, action) => {
    switch (action.type) {
        case "SET_All_SESSIONS":
            return {
                ...state,
                allSessions: action.payload.data,
            };
        case "SET_SESSIONS_FOR_TODAY":
            return {
                ...state,
                sessionsForToday: action.payload.data,
            };
        case "SET_CURRENT_STAFF_SESSIONS_FOR_TODAY":
            return {
                ...state,
                currentStaffSessionsForToday: action.payload.data,
            };
        case "SET_CURRENT_STAFF_ACTIVE_SESSION":
            return {
                ...state,
                currentStaffActiveSession: action.payload.data,
            };
        case "SET_CURRENT_STAFF_SESSIONS_TO_VERIFY":
            return {
                ...state,
                currentStaffSessionsToVerify: action.payload.data,
            };
        case "SET_START_STAFF_SESSION_MODAL_OPEN":
            return {
                ...state,
                startSessionModalOpen: action.payload.data,
            };
        case "SET_END_STAFF_SESSION_MODAL_OPEN":
            return {
                ...state,
                endSessionModalOpen: action.payload.data,
                sessionIdToBeClosed: action.payload.sessionId,
            };
        case "SET_VERIFY_AND_INFO_STAFF_SESSIONS_MODAL_OPEN":
            return {
                ...state,
                verifyAndInfoSessionsModalOpen: action.payload.data,
            };
        case "SET_CONFIRM_CLOSE_STAFF_SESSION_MODAL_OPEN":
            return {
                ...state,
                confirmCloseStaffSessionModalOpen: action.payload.data,
                confirmCloseStaffSessionOpenedID: action.payload.openedSession,
            };
        default:
            return { ...state };
        
    }
};

export default StaffSessionReducer;